// Fixed colour palette for charts (recharts etc.). Chart libraries need real
// colour values rather than CSS variables, so the palette lives here; use
// these instead of hard-coded hex values so every chart matches.
export const CHART_COLORS = [
  "#4f46e5", // indigo (primary)
  "#0d9488", // teal (success)
  "#f59e0b", // amber
  "#e11d48", // rose
  "#0ea5e9", // sky
  "#7c3aed", // violet
  "#84cc16", // lime
  "#f97316", // orange
];

// Fixed meanings, e.g. present/absent, pass/fail
export const CHART_STATUS_COLORS = {
  positive: "#0d9488",
  negative: "#e11d48",
  warning: "#f59e0b",
  neutral: "#94a3b8",
  track: "#e2e8f0", // empty part of progress donuts/bars
};

export const chartColor = (index) => CHART_COLORS[index % CHART_COLORS.length];
